import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import API_URL from "../config";
import { FaPlus, FaSave, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const API = `${API_URL}/api/horarios`;

const API_PROFESORES = `${API_URL}/api/profesores`;

export default function GestionarHorarios() {


const crearFormInicial = () => ({
  tipo: "normal",
  profesor_ids: [],
  configuracion_id: "",
  fecha: "",
  dia_semana: "",
  hora_inicio: "",
  hora_fin: "",
  descanso_minutos: 0
});

  const [profesores, setProfesores] = useState([]);
  const [configuraciones, setConfiguraciones] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [tempHorarios, setTempHorarios] = useState([]);
  const [seleccionados, setSeleccionados] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  const [duracionFiltro, setDuracionFiltro] = useState("");
const [horaFiltro, setHoraFiltro] = useState("");
const [estadoFiltro, setEstadoFiltro] = useState("activos");
const [fechaDesde, setFechaDesde] = useState("");
const [fechaHasta, setFechaHasta] = useState("");
const [tipoCreacionFiltro, setTipoCreacionFiltro] = useState("todos");

/* ================= EDITAR HORARIO EXISTENTE =================
   Si el horario tiene lote_id (se creó después de agregar esta función),
   se edita el LOTE completo (todas las fechas que se crearon juntas),
   y si era semanal se puede cambiar el día de la semana. Si no tiene
   lote_id (horario viejo, de antes de esto), se edita solo esa fila,
   como al inicio.
================================================================= */
const [editandoHorario, setEditandoHorario] = useState(null);
const [formEdicion, setFormEdicion] = useState({
  configuracion_id: "",
  fecha: "",
  dia_semana: "",
  hora_inicio: "",
  hora_fin: "",
});

const diasSemana = [
  { value: "1", label: "Lunes" },
  { value: "2", label: "Martes" },
  { value: "3", label: "Miércoles" },
  { value: "4", label: "Jueves" },
  { value: "5", label: "Viernes" },
  { value: "6", label: "Sábado" },
  { value: "0", label: "Domingo" },
];





  const [pagina, setPagina] = useState(1);
  const porPagina = 40;
  const [form, setForm] = useState(crearFormInicial());

  // Combobox de docentes con checkboxes — permite marcar uno, varios o
  // todos los activos a la vez, en vez de un <select> de una sola opción.
  const [docenteDropdownAbierto, setDocenteDropdownAbierto] = useState(false);
  const docenteDropdownRef = useRef(null);

  useEffect(() => {
    if (!docenteDropdownAbierto) return;
    const cerrarSiEsAfuera = (e) => {
      if (docenteDropdownRef.current && !docenteDropdownRef.current.contains(e.target)) {
        setDocenteDropdownAbierto(false);
      }
    };
    document.addEventListener("mousedown", cerrarSiEsAfuera);
    return () => document.removeEventListener("mousedown", cerrarSiEsAfuera);
  }, [docenteDropdownAbierto]);

  const alternarProfesor = (id) => {
    setForm((prev) => ({
      ...prev,
      profesor_ids: prev.profesor_ids.includes(id)
        ? prev.profesor_ids.filter((x) => x !== id)
        : [...prev.profesor_ids, id],
    }));
  };

  // Atajos para no tener que volver a marcar los mismos profesores cada
  // vez que se agrega un nuevo rango de horario para el mismo grupo.
  const seleccionarGuiasDeGrado = () => {
    const ids = profesores.filter(p => p.activo && p.grado_guia_id).map(p => p.id);
    if (ids.length === 0) {
      alert("⚠️ No hay profesores activos marcados como guía de grado.");
      return;
    }
    setForm(prev => ({ ...prev, profesor_ids: ids }));
  };

  const seleccionarTodosLosProfesores = () => {
    const ids = profesores.filter(p => p.activo).map(p => p.id);
    setForm(prev => ({ ...prev, profesor_ids: ids }));
  };

  // Atajo por etiqueta(s) (ej. "Claustro Academico", "Primaria"...) — igual
  // patrón que seleccionarGuiasDeGrado/seleccionarTodosLosProfesores, pero
  // filtrando por las etiquetas que el admin marque en el combo de al lado.
  // El catálogo se trae del propio CRUD de "Gestionar Etiquetas Docentes"
  // (no de los profesores), así aparecen todas aunque nadie las tenga
  // asignada todavía, y las nuevas que se creen aparecen solas.
  const [etiquetas, setEtiquetas] = useState([]);
  const [etiquetasSeleccionadas, setEtiquetasSeleccionadas] = useState([]);
  const [etiquetaDropdownAbierto, setEtiquetaDropdownAbierto] = useState(false);
  const etiquetaDropdownRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/etiquetas-docentes`)
      .then(res => setEtiquetas(res.data || []))
      .catch(err => console.error("Error cargando etiquetas", err));
  }, []);

  useEffect(() => {
    if (!etiquetaDropdownAbierto) return;
    const cerrarSiEsAfuera = (e) => {
      if (etiquetaDropdownRef.current && !etiquetaDropdownRef.current.contains(e.target)) {
        setEtiquetaDropdownAbierto(false);
      }
    };
    document.addEventListener("mousedown", cerrarSiEsAfuera);
    return () => document.removeEventListener("mousedown", cerrarSiEsAfuera);
  }, [etiquetaDropdownAbierto]);

  // Marca en el combobox de docentes, EN VIVO, a todos los profesores
  // activos que tengan alguna de las etiquetas marcadas — no hace falta
  // ningún botón aparte, igual que tildar un docente directamente.
  const aplicarSeleccionPorEtiquetas = (idsEtiquetas) => {
    const ids = profesores
      .filter(p => p.activo && idsEtiquetas.some(id => String(id) === String(p.etiqueta_id)))
      .map(p => p.id);
    setForm(prev => ({ ...prev, profesor_ids: ids }));
  };

  const alternarEtiqueta = (id) => {
    setEtiquetasSeleccionadas(prev => {
      const nuevo = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
      aplicarSeleccionPorEtiquetas(nuevo);
      return nuevo;
    });
  };

  const alternarTodasLasEtiquetas = () => {
    const yaEstanTodas = etiquetas.length > 0 && etiquetas.every(e => etiquetasSeleccionadas.includes(e.id));
    const nuevo = yaEstanTodas ? [] : etiquetas.map(e => e.id);
    setEtiquetasSeleccionadas(nuevo);
    aplicarSeleccionPorEtiquetas(nuevo);
  };

  const textoEtiquetasSeleccionadas = () => {
    if (etiquetasSeleccionadas.length === 0) return "Por etiqueta...";
    if (etiquetas.length > 0 && etiquetas.every(e => etiquetasSeleccionadas.includes(e.id))) {
      return "🏷️ Todas las etiquetas";
    }
    return etiquetas
      .filter(e => etiquetasSeleccionadas.includes(e.id))
      .map(e => e.nombre)
      .join(", ");
  };

  const alternarTodosProfesores = () => {
    const idsActivos = profesores.filter((p) => p.activo).map((p) => p.id);
    const yaEstanTodos =
      idsActivos.length > 0 && idsActivos.every((id) => form.profesor_ids.includes(id));
    setForm((prev) => ({ ...prev, profesor_ids: yaEstanTodos ? [] : idsActivos }));
  };

  const textoDocentesSeleccionados = (ids) => {
    if (!ids || ids.length === 0) return "Selecciona uno o varios...";
    const idsActivos = profesores.filter((p) => p.activo).map((p) => p.id);
    const sonTodosLosActivos =
      idsActivos.length > 0 &&
      ids.length === idsActivos.length &&
      idsActivos.every((id) => ids.includes(id));
    if (sonTodosLosActivos) return "👥 Todos los profesores activos";
    return ids
      .map((id) => profesores.find((p) => p.id === id)?.nombre)
      .filter(Boolean)
      .join(", ");
  };

useEffect(() => {
  cargarTodo();
  cargarListaConfiguraciones();
}, []);


  const cargarTodo = async () => {
    try {
      // 🔥 cache-busting: evita que el navegador/CDN devuelva datos viejos
      // después de crear/activar/desactivar/eliminar horarios
      const p = await axios.get(`${API_PROFESORES}?t=${Date.now()}`);
      const h = await axios.get(`${API}/todos?t=${Date.now()}`);
      setProfesores(p.data);
      setHorarios(h.data);
    } catch {
      alert("❌ Error conectando backend");
    }
  };


/* 🔥 Lista de configuraciones por servicio, para elegir la duración
   de cita al crear horarios (pantalla "Configuraciones") */
const cargarListaConfiguraciones = async () => {
  try {
    const res = await axios.get(`${API_URL}/api/configuraciones-horarios`);
    setConfiguraciones(res.data || []);
  } catch (err) {
    console.error("Error cargando lista de configuraciones", err);
  }
};



  const validarFechaHora = () => {
    if (form.tipo === "semanal") return true;

    if (!form.fecha) {
      alert("⚠️ Seleccione la fecha");
      return false;
    }

    const ahora = new Date();

    // 🔥 parseo en hora LOCAL (no UTC) para evitar el bug de "hoy = ayer"
    // en zonas horarias detrás de UTC (ej. Nicaragua, UTC-6)
    const [anioSel, mesSel, diaSel] = form.fecha.split("-").map(Number);
    const fechaSeleccionada = new Date(anioSel, mesSel - 1, diaSel);
    fechaSeleccionada.setHours(0, 0, 0, 0);

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    if (fechaSeleccionada < hoy) {
      alert("⛔ No puedes crear horarios en fechas pasadas");
      return false;
    }

    const hoyLocal = new Date();
    const hoyTexto = `${hoyLocal.getFullYear()}-${String(hoyLocal.getMonth() + 1).padStart(2, "0")}-${String(hoyLocal.getDate()).padStart(2, "0")}`;
    if (form.fecha === hoyTexto) {
      const [h, m] = form.hora_inicio.split(":").map(Number);
      const fechaHoraInicio = new Date();
      fechaHoraInicio.setHours(h, m, 0, 0);

      if (fechaHoraInicio <= ahora) {
        alert("⛔ La hora ya pasó. Selecciona una hora futura");
        return false;
      }
    }

    const inicio = form.hora_inicio.split(":").map(Number);
    const fin = form.hora_fin.split(":").map(Number);

    if (fin[0] * 60 + fin[1] <= inicio[0] * 60 + inicio[1]) {
      alert("⛔ Hora fin debe ser mayor");
      return false;
    }

    return true;
  };

  const agregarTemporal = () => {
    if (!form.profesor_ids || form.profesor_ids.length === 0)
      return alert("⚠️ Selecciona al menos un profesor");
    if (!form.configuracion_id) return alert("⚠️ Selecciona una configuración");
    if (!form.hora_inicio || !form.hora_fin) return alert("⚠️ Ingresa horas");
    if (!validarFechaHora()) return;

    setTempHorarios([
      ...tempHorarios,
      { ...form, profesor_nombre: textoDocentesSeleccionados(form.profesor_ids) }
    ]);

    setForm(crearFormInicial());
    setEtiquetasSeleccionadas([]);
  };

  const eliminarTemp = (i) => {
    const copia = [...tempHorarios];
    copia.splice(i, 1);
    setTempHorarios(copia);
  };



const guardarTodo = async () => {
  if (tempHorarios.length === 0)
    return alert("⚠️ No hay horarios");

  // Se arma la lista completa de combinaciones (horario × profesor) que
  // se van a crear en este "Guardar".
  const combos = [];
  for (const h of tempHorarios) {
    const payload = {
      tipo: h.tipo,
      configuracion_id: h.configuracion_id || null,
      fecha: h.fecha,
      dia_semana: h.dia_semana,
      hora_inicio: h.hora_inicio,
      hora_fin: h.hora_fin,
      descanso_minutos: Number(h.descanso_minutos) || 0
    };
    for (const profesorId of h.profesor_ids) {
      combos.push({ payload, profesorId });
    }
  }

  // 🔎 PASO 0: revisar que no se crucen ENTRE SÍ dos entradas de esta
  // misma vista previa (ej. agregar por error el mismo horario dos veces
  // para el mismo profesor) — esto no lo puede detectar el servidor
  // porque, tomadas una por una, ninguna existe todavía en la BD.
  const rangosSeCruzan = (inicio1, fin1, inicio2, fin2) => inicio1 < fin2 && fin1 > inicio2;
  const conflictosEnLote = [];
  for (let i = 0; i < combos.length; i++) {
    for (let j = i + 1; j < combos.length; j++) {
      const a = combos[i];
      const b = combos[j];
      if (a.profesorId !== b.profesorId) continue;
      if (a.payload.tipo !== b.payload.tipo) continue;
      if (a.payload.tipo === "normal" && a.payload.fecha !== b.payload.fecha) continue;
      if (a.payload.tipo === "semanal" && a.payload.dia_semana !== b.payload.dia_semana) continue;
      if (!rangosSeCruzan(a.payload.hora_inicio, a.payload.hora_fin, b.payload.hora_inicio, b.payload.hora_fin)) continue;
      const nombreProf = profesores.find(p => p.id === a.profesorId)?.nombre || `#${a.profesorId}`;
      conflictosEnLote.push(`${nombreProf}: dos entradas de la vista previa se cruzan entre sí (${a.payload.hora_inicio}-${a.payload.hora_fin})`);
    }
  }
  if (conflictosEnLote.length > 0) {
    alert(
      `❌ No se creó ningún horario — hay entradas de la vista previa que se cruzan entre sí:\n\n- ${conflictosEnLote.join("\n- ")}\n\nQuita una de las dos (❌) e intenta de nuevo.`
    );
    return;
  }

  // 🔎 PASO 1: validar TODO el lote antes de crear nada — si un solo
  // profesor/rango tiene conflicto, no se crea NINGUNO de los demás,
  // para no terminar con una creación a medias y confundirse sobre qué
  // sí quedó y qué no.
  const conflictos = [];
  for (const { payload, profesorId } of combos) {
    const nombreProf = profesores.find(p => p.id === profesorId)?.nombre || `#${profesorId}`;
    try {
      await axios.post(`${API}/crear`, { ...payload, profesor_id: profesorId, soloValidar: true });
    } catch (err) {
      const mensaje = err.response?.data?.error || "Error desconocido";
      conflictos.push(`${nombreProf}: ${mensaje}`);
    }
  }

  if (conflictos.length > 0) {
    alert(
      `❌ No se creó ningún horario — hay conflicto(s):\n\n- ${conflictos.join("\n- ")}\n\nCorrige o quita esos de la vista previa e intenta de nuevo.`
    );
    return;
  }

  // 🟢 PASO 2: ya se validó todo el lote sin conflictos, ahora sí se crea.
  const exitosos = [];
  const omitidos = [];
  const fallidos = [];

  for (const { payload, profesorId } of combos) {
    const nombreProf = profesores.find(p => p.id === profesorId)?.nombre || `#${profesorId}`;
    try {
      const respuesta = await axios.post(`${API}/crear`, { ...payload, profesor_id: profesorId });
      exitosos.push(nombreProf);
      const fechasOmitidas = respuesta.data?.fechas_omitidas_por_cruce || [];
      if (fechasOmitidas.length > 0) {
        omitidos.push(`${nombreProf}: ${fechasOmitidas.length} fecha(s) ya tenían horario cruzado y se omitieron`);
      }
    } catch (err) {
      // No debería pasar (ya se validó en el paso 1), pero por si otro
      // admin creó algo al mismo tiempo, se avisa igual sin ocultarlo.
      const mensaje = err.response?.data?.error || "Error desconocido";
      fallidos.push(`${nombreProf}: ${mensaje}`);
    }
  }

  let resumen = `✅ ${exitosos.length} horario(s) creado(s) correctamente.`;
  if (omitidos.length > 0) {
    resumen += `\n\n⚠️ Con algunas fechas omitidas por cruce:\n- ${omitidos.join("\n- ")}`;
  }
  if (fallidos.length > 0) {
    resumen += `\n\n❌ No se pudieron crear:\n- ${fallidos.join("\n- ")}`;
  }
  alert(resumen);

  setTempHorarios([]);
  setForm(crearFormInicial());
  setEtiquetasSeleccionadas([]);
  cargarTodo();
};







// cambios nuevos


const toggleSeleccion = (id) => {
  if (seleccionados.includes(id)) {
    setSeleccionados(
      seleccionados.filter(x => x !== id)
    );
  } else {
    setSeleccionados([
      ...seleccionados,
      id
    ]);
  }
};







  // 🔥 CORREGIDO: selecciona TODOS los filtrados, no solo la página




  const seleccionarTodos = () => {
    setSeleccionados(filtrados.map(h => h.id));
  };

  const quitarSeleccion = () => setSeleccionados([]);

  const validarSeleccion = () => {
    if (seleccionados.length === 0) {
      alert("⚠️ Seleccione horarios");
      return false;
    }
    return true;
  };

  const activar = async () => {
    if (!validarSeleccion()) return;

    const res = await axios.post(`${API}/activar`, { ids: seleccionados });

    const total = seleccionados.length;
    const activados = res.data?.activados ?? total;

    if (activados < total) {
      alert(
        `✅ Se activaron ${activados} de ${total} horarios.\n` +
        `⚠️ ${total - activados} no se activaron porque su fecha/hora ya pasó, o porque ya tienen una cita agendada.`
      );
    }

    quitarSeleccion();
    cargarTodo();
  };

  const desactivar = async () => {
    if (!validarSeleccion()) return;
    await axios.post(`${API}/desactivar`, { ids: seleccionados });
    quitarSeleccion();
    cargarTodo();
  };

const eliminar = async () => {

  if (!validarSeleccion()) return;

  if (!window.confirm("Eliminar?")) return;

  try {

    const res = await axios.post(
      `${API}/eliminar`,
      { ids: seleccionados }
    );

    alert("✅ Horarios eliminados");

    quitarSeleccion();

    cargarTodo();

  } catch (err) {

    console.error(err);

    // 🔥 mensaje personalizado del backend
    if (err.response?.data?.error) {

      alert(err.response.data.error);

    } else {

      alert("❌ Error eliminando horarios");
    }
  }
};

/* ================= EDITAR HORARIO EXISTENTE ================= */
const abrirEdicionHorario = (h) => {
  setEditandoHorario(h);

  // 🔥 día de la semana calculado en hora LOCAL (mismo cuidado que el
  // bug de "hoy=ayer" que ya arreglamos antes con new Date(string))
  let diaSemanaCalculado = "";
  if (h.fecha) {
    const [anio, mes, dia] = h.fecha.split("T")[0].split("-").map(Number);
    diaSemanaCalculado = String(new Date(anio, mes - 1, dia).getDay());
  }

  setFormEdicion({
    configuracion_id: "",
    fecha: h.fecha ? h.fecha.split("T")[0] : "",
    dia_semana: diaSemanaCalculado,
    hora_inicio: h.hora_inicio?.slice(0, 5) || "",
    hora_fin: h.hora_fin?.slice(0, 5) || "",
  });
};

const cerrarEdicionHorario = () => {
  setEditandoHorario(null);
};

const guardarEdicionHorario = async () => {
  if (!formEdicion.hora_inicio || !formEdicion.hora_fin) {
    alert("⚠️ Completa las horas");
    return;
  }

  const esLote = !!editandoHorario.lote_id;
  const esSemanal = editandoHorario.tipo_creacion === "semanal";

  if (esLote && !formEdicion.configuracion_id) {
    alert("⚠️ Selecciona una configuración");
    return;
  }

  try {

    if (!esLote) {
      // Horario viejo, sin lote — se edita solo esa fila (como antes)
      if (!formEdicion.fecha) {
        alert("⚠️ Completa la fecha");
        return;
      }

      await axios.post(`${API}/${editandoHorario.id}/editar`, {
        fecha: formEdicion.fecha,
        hora_inicio: formEdicion.hora_inicio,
        hora_fin: formEdicion.hora_fin,
      });

    } else if (esSemanal) {
      // Lote semanal — cambia el día de la semana / hora de toda la serie futura
      await axios.post(`${API}/lote/${editandoHorario.lote_id}/editar-semanal`, {
        configuracion_id: formEdicion.configuracion_id,
        dia_semana: formEdicion.dia_semana,
        hora_inicio: formEdicion.hora_inicio,
        hora_fin: formEdicion.hora_fin,
      });

    } else {
      // Lote por fecha — reemplaza todo el bloque que se creó junto
      if (!formEdicion.fecha) {
        alert("⚠️ Completa la fecha");
        return;
      }

      await axios.post(`${API}/lote/${editandoHorario.lote_id}/editar-fecha`, {
        configuracion_id: formEdicion.configuracion_id,
        fecha: formEdicion.fecha,
        hora_inicio: formEdicion.hora_inicio,
        hora_fin: formEdicion.hora_fin,
      });
    }

    alert("✅ Horario actualizado");
    cerrarEdicionHorario();
    cargarTodo();

  } catch (err) {
    console.error(err);
    alert(err.response?.data?.error || "❌ Error actualizando el horario");
  }
};




  const calcularDuracion = (h) => {
    const [hi, mi] = h.hora_inicio.split(":").map(Number);
    const [hf, mf] = h.hora_fin.split(":").map(Number);
    return hf * 60 + mf - (hi * 60 + mi);
  };

  const formatearFecha = f =>
    f ? new Date(f).toLocaleDateString() : "";

  const formatearHora = h => {
    let [hh, mm] = h.split(":");
    hh = parseInt(hh);
    const am = hh >= 12 ? "PM" : "AM";
    hh = hh % 12 || 12;
    return `${hh}:${mm} ${am}`;
  };


const hoy = new Date();

const filtrados = horarios.filter(h => {

  // 🔍 búsqueda profesor
  const coincideProfesor =
    h.profesor_nombre
      ?.toLowerCase()
      .includes(busqueda.toLowerCase());

  // ⏱ duración
  const coincideDuracion =
    !duracionFiltro ||
    calcularDuracion(h) == duracionFiltro;

  // 🕐 hora de inicio específica (para encontrar el mismo horario
  // en todos los profesores a la vez, ej. "10:30" los agrupa a todos)
  const coincideHora =
    !horaFiltro ||
    h.hora_inicio?.startsWith(horaFiltro);

  // 🔁 tipo de creación (semanal / por fecha)
  const coincideTipoCreacion =
    tipoCreacionFiltro === "todos" ||
    h.tipo_creacion === tipoCreacionFiltro;

  // ✅ estado
  let coincideEstado = true;

  if (estadoFiltro === "activos") {
    coincideEstado = h.disponible == 1;
  }

  if (estadoFiltro === "inactivos") {
    coincideEstado = h.disponible == 0;
  }

  // 📅 rango fechas (fechas armadas por componentes para evitar el corrimiento
  // de un día que causa new Date("YYYY-MM-DD") al interpretarse como UTC)
  let coincideFecha = true;

  const [anioH, mesH, diaH] = h.fecha.split("T")[0].split("-").map(Number);
  const fechaHorarioLocal = new Date(anioH, mesH - 1, diaH);

  if (fechaDesde) {
    const [anioD, mesD, diaD] = fechaDesde.split("-").map(Number);
    const desde = new Date(anioD, mesD - 1, diaD);
    coincideFecha = coincideFecha && fechaHorarioLocal >= desde;
  }

  if (fechaHasta) {
    const [anioF, mesF, diaF] = fechaHasta.split("-").map(Number);
    const hasta = new Date(anioF, mesF - 1, diaF);
    hasta.setHours(23,59,59,999);

    coincideFecha = coincideFecha && fechaHorarioLocal <= hasta;
  }

  return (
    coincideProfesor &&
    coincideDuracion &&
    coincideHora &&
    coincideTipoCreacion &&
    coincideEstado &&
    coincideFecha
  );

}).sort((a, b) => {

  // 📅 En "Inactivos": más reciente primero (fecha desc, luego hora desc)
  if (estadoFiltro !== "inactivos") return 0;

  const diffFecha = new Date(b.fecha) - new Date(a.fecha);
  if (diffFecha !== 0) return diffFecha;

  return (b.hora_inicio || "").localeCompare(a.hora_inicio || "");
});




  const totalPaginas = Math.ceil(filtrados.length / porPagina);
  const data = filtrados.slice(
    (pagina - 1) * porPagina,
    pagina * porPagina
  );

  return (
    <div className="contenedor">
      <h1>📅 Gestión Profesional de Horarios</h1>


      {/* FORMULARIO */}
      <div className="card">
        <h3>➕ Crear horarios</h3>



<div className="formGrid">

  <div className="campo">
    <label>Tipo horario</label>
    <select
      value={form.tipo}
      onChange={e => setForm({ ...form, tipo: e.target.value })}
    >
      <option value="normal">📅 Por fecha</option>
      <option value="semanal">🔁 Semanal</option>
    </select>
  </div>

  <div className="campo" ref={docenteDropdownRef} style={{ position: "relative" }}>
    <label>Seleccione el/los docente(s)</label>
    <button
      type="button"
      onClick={() => setDocenteDropdownAbierto(v => !v)}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 8,
        padding: "8px 10px",
        borderRadius: 6,
        border: "1px solid #ccc",
        background: "#fff",
        cursor: "pointer",
        textAlign: "left",
      }}
    >
      <span
        style={{
          color: form.profesor_ids.length ? "#111" : "#888",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {textoDocentesSeleccionados(form.profesor_ids)}
      </span>
      <span>{docenteDropdownAbierto ? "▲" : "▼"}</span>
    </button>

    {docenteDropdownAbierto && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          zIndex: 30,
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: 6,
          marginTop: 4,
          maxHeight: 260,
          overflowY: "auto",
          boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
          padding: "6px 10px",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "5px 0",
            fontWeight: 600,
            borderBottom: "1px solid #eee",
            marginBottom: 4,
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={
              profesores.some(p => p.activo) &&
              profesores.filter(p => p.activo).every(p => form.profesor_ids.includes(p.id))
            }
            onChange={alternarTodosProfesores}
          />
          👥 Todos los profesores activos
        </label>
        {profesores.map(p => (
          <label
            key={p.id}
            style={{ display: "flex", alignItems: "center", gap: 8, padding: "3px 0", cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={form.profesor_ids.includes(p.id)}
              onChange={() => alternarProfesor(p.id)}
            />
            {p.nombre}{!p.activo ? " (inactivo)" : ""}
          </label>
        ))}
      </div>
    )}
  </div>

  <div className="campo">
    <label>Configuración (duración de cita)</label>
    <select
      value={form.configuracion_id}
      onChange={e => setForm({ ...form, configuracion_id: e.target.value })}
    >
      <option value="">Selecciona una configuración</option>
      {configuraciones.map(c => (
        <option key={c.id} value={c.id}>
          {c.nombre} — {c.intervalo_citas_minutos} min
        </option>
      ))}
    </select>
  </div>

  <div className="campo">
    <label>Descanso entre citas (min)</label>
    <input
      type="number"
      min="0"
      placeholder="0"
      value={form.descanso_minutos}
      onChange={e => setForm({ ...form, descanso_minutos: e.target.value })}
      title="Minutos libres entre el fin de una cita y el inicio de la siguiente, dentro de este mismo rango"
    />
  </div>

  {form.tipo === "normal" ? (
    <div className="campo">
      <label>Seleccione la fecha</label>
      <input
        type="date"
        value={form.fecha}
        onChange={e => setForm({ ...form, fecha: e.target.value })}
      />
    </div>
  ) : (
    <div className="campo">
      <label>Día semana</label>
      <select
        value={form.dia_semana}
        onChange={e => setForm({ ...form, dia_semana: e.target.value })}
      >
        <option value="">Día</option>
        <option value="1">Lunes</option>
        <option value="2">Martes</option>
        <option value="3">Miércoles</option>
        <option value="4">Jueves</option>
        <option value="5">Viernes</option>
        <option value="6">Sábado</option>
        <option value="0">Domingo</option>
      </select>
    </div>
  )}

  {/* HORA INICIO */}
  <div className="campo">
    <label>Hora inicio</label>
    <input
      type="time"
      value={form.hora_inicio}
      onChange={e => setForm({ ...form, hora_inicio: e.target.value })}
    />
  </div>

  {/* HORA FIN */}
  <div className="campo">
    <label>Hora fin</label>
    <input
      type="time"
      value={form.hora_fin}
      onChange={e => setForm({ ...form, hora_fin: e.target.value })}
    />
  </div>
</div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 4 }}>
          <button className="btn btn-sm primary" onClick={agregarTemporal}>
            <FaPlus /> Añadir
          </button>
          <button className="btn btn-sm success" onClick={guardarTodo}>
            <FaSave /> Guardar
          </button>

          {/* Atajos de selección rápida de docentes — sin tener que volver
              a marcar checkbox por checkbox cada vez que se agrega un
              rango nuevo para el mismo grupo (ej. varios rangos para las
              guías). */}
          <button
            type="button"
            className="btn btn-sm"
            onClick={seleccionarGuiasDeGrado}
            style={{ background: "#6d28d9", color: "#fff" }}
            title="Marca a todos los profesores que son guía de algún grado"
          >
            🎓 Horarios Guías
          </button>
          <button
            type="button"
            className="btn btn-sm"
            onClick={seleccionarTodosLosProfesores}
            style={{ background: "#334155", color: "#fff" }}
            title="Marca a todos los profesores activos"
          >
            👥 General (Todos)
          </button>

          {etiquetas.length > 0 && (
            <div style={{ display: "flex", gap: 4 }}>
              <div ref={etiquetaDropdownRef} style={{ position: "relative" }}>
                <button
                  type="button"
                  onClick={() => setEtiquetaDropdownAbierto(v => !v)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "0 10px",
                    height: "100%",
                    minHeight: 30,
                    borderRadius: 6,
                    border: "1px solid #ccc",
                    background: "#fff",
                    cursor: "pointer",
                    maxWidth: 220,
                  }}
                >
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13 }}>
                    {textoEtiquetasSeleccionadas()}
                  </span>
                  <span>{etiquetaDropdownAbierto ? "▲" : "▼"}</span>
                </button>

                {etiquetaDropdownAbierto && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      zIndex: 30,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: 6,
                      marginTop: 4,
                      maxHeight: 220,
                      minWidth: 200,
                      overflowY: "auto",
                      boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                      padding: "6px 10px",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "5px 0",
                        fontWeight: 600,
                        borderBottom: "1px solid #eee",
                        marginBottom: 4,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={etiquetas.length > 0 && etiquetas.every(e => etiquetasSeleccionadas.includes(e.id))}
                        onChange={alternarTodasLasEtiquetas}
                      />
                      🏷️ Todas las etiquetas
                    </label>
                    {etiquetas.map(e => (
                      <label
                        key={e.id}
                        style={{ display: "flex", alignItems: "center", gap: 8, padding: "3px 0", cursor: "pointer" }}
                      >
                        <input
                          type="checkbox"
                          checked={etiquetasSeleccionadas.includes(e.id)}
                          onChange={() => alternarEtiqueta(e.id)}
                        />
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: 3,
                            background: e.color || "#94a3b8",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        {e.nombre}
                      </label>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* VISTA PREVIA */}
      {tempHorarios.length > 0 && (
        <div className="card">
          <h3>Vista previa</h3>
          <div style={{ overflowX: "auto" }}>
          <table className="tabla">
            <tbody>
              {tempHorarios.map((h, i) => (
                <tr key={i}>
                  <td>{h.profesor_nombre}</td>
                  <td>
                    {h.tipo === "normal"
                      ? formatearFecha(h.fecha)
                      : "Semanal"}
                  </td>
                  <td>
                    {formatearHora(h.hora_inicio)} -{" "}
                    {formatearHora(h.hora_fin)}
                  </td>
                  <td>
                    {Number(h.descanso_minutos) > 0
                      ? `Descanso: ${h.descanso_minutos} min`
                      : "Sin descanso"}
                  </td>
                  <td>
                    <button
                      onClick={() => eliminarTemp(i)}
                      className="btn danger"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {/* TOOLBAR */}
      <div className="card toolbar">
        <input
          placeholder="🔎 Buscar profesor"
          onChange={e => setBusqueda(e.target.value)}
        />
        <input
          placeholder="Duración (min)"
          onChange={e => setDuracionFiltro(e.target.value)}
        />
        <input
          type="time"
          title="Buscar por hora de inicio — muestra ese horario en todos los profesores a la vez"
          value={horaFiltro}
          onChange={e => setHoraFiltro(e.target.value)}
        />
<select
  value={estadoFiltro}
  onChange={e => setEstadoFiltro(e.target.value)}
>
  <option value="activos">🟢 Activos</option>
  <option value="inactivos">⚫ Inactivos</option>
  <option value="todos">📋 Todos</option>
</select>

<select
  value={tipoCreacionFiltro}
  onChange={e => setTipoCreacionFiltro(e.target.value)}
>
  <option value="todos">📋 Semanal y por fecha</option>
  <option value="semanal">🔁 Solo semanal</option>
  <option value="normal">📅 Solo por fecha</option>
</select>

<input
  type="date"
  value={fechaDesde}
  onChange={e => setFechaDesde(e.target.value)}
/>

<input
  type="date"
  value={fechaHasta}
  onChange={e => setFechaHasta(e.target.value)}
/>



        <button className="btn success" onClick={activar}>
          <FaCheck /> Activar
        </button>
        <button className="btn warning" onClick={desactivar}>
          <FaTimes /> Desactivar
        </button>
        <button className="btn danger" onClick={eliminar}>
          <FaTrash /> Eliminar
        </button>

        <button className="btn primary" onClick={seleccionarTodos}>
          Seleccionar todo
        </button>
        <button className="btn secondary" onClick={quitarSeleccion}>
          Quitar selección
        </button>
      </div>

      {/* TABLA — solo escritorio */}
      <div className="card hidden md:block">
        <div style={{ overflowX: "auto" }}>
        <table className="tabla">
          <thead>
            <tr>
              <th></th>
              <th>Profesor</th>
              <th>Tipo</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Duración</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {data.map(h => (
              <tr key={h.id} className={h.disponible ? "tr-activo" : "tr-inactivo"}>
                <td>
                  <input
                    type="checkbox"
                    checked={seleccionados.includes(h.id)}
                    onChange={() => toggleSeleccion(h.id)}
                  />
                </td>
                <td>{h.profesor_nombre}</td>
                <td>
                  <span className={`badge ${h.tipo_creacion === "semanal" ? "tipo-semanal" : "tipo-fecha"}`}>
                    {h.tipo_creacion === "semanal" ? "🔁 Semanal" : "📅 Fecha"}
                  </span>
                </td>
                <td>{formatearFecha(h.fecha)}</td>
                <td>
                  {formatearHora(h.hora_inicio)} -{" "}
                  {formatearHora(h.hora_fin)}
                </td>
                <td>{calcularDuracion(h)} min</td>
                <td>
                  <span
                    className={`badge ${
                      h.disponible ? "activo" : "inactivo"
                    }`}
                  >
                    {h.disponible ? "Activo" : "Inactivo"}
                  </span>
                </td>
                <td>
                  <button
                    className="btn primary btn-sm"
                    onClick={() => abrirEdicionHorario(h)}
                  >
                    ✏️ Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        <div className="paginacion flex justify-center items-center gap-2 p-4">
          <button
            disabled={pagina === 1}
            onClick={() => setPagina(p => p - 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Anterior
          </button>
          <span>
            Página {pagina} de {totalPaginas || 1}
          </span>
          <button
            disabled={pagina === totalPaginas}
            onClick={() => setPagina(p => p + 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Siguiente
          </button>
        </div>
      </div>

      {/* TARJETAS — solo móvil */}
      <div className="card md:hidden" style={{ padding: 12 }}>
        <div className="flex flex-col gap-3">
          {data.map(h => (
            <div
              key={h.id}
              className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 flex flex-col gap-2"
              style={{ borderLeft: `4px solid ${h.disponible ? "#22c55e" : "#ef4444"}` }}
            >
              <div className="flex justify-between items-start gap-2">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={seleccionados.includes(h.id)}
                    onChange={() => toggleSeleccion(h.id)}
                  />
                  <span className="font-bold text-gray-800">{h.profesor_nombre}</span>
                </label>
                <div className="flex flex-col items-end gap-1">
                  <span className={`badge ${h.disponible ? "activo" : "inactivo"}`}>
                    {h.disponible ? "Activo" : "Inactivo"}
                  </span>
                  <span className={`badge ${h.tipo_creacion === "semanal" ? "tipo-semanal" : "tipo-fecha"}`}>
                    {h.tipo_creacion === "semanal" ? "🔁 Semanal" : "📅 Fecha"}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1 text-sm">
                <span className="text-gray-400">Fecha:</span>
                <span className="text-gray-800">{formatearFecha(h.fecha)}</span>

                <span className="text-gray-400">Hora:</span>
                <span className="text-gray-800">
                  {formatearHora(h.hora_inicio)} - {formatearHora(h.hora_fin)}
                </span>

                <span className="text-gray-400">Duración:</span>
                <span className="text-gray-800">{calcularDuracion(h)} min</span>
              </div>

              <button
                className="btn primary btn-sm"
                onClick={() => abrirEdicionHorario(h)}
                style={{ alignSelf: "flex-start" }}
              >
                ✏️ Editar
              </button>
            </div>
          ))}
        </div>

        <div className="paginacion flex justify-center items-center gap-2 p-4">
          <button
            disabled={pagina === 1}
            onClick={() => setPagina(p => p - 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Anterior
          </button>
          <span>
            Página {pagina} de {totalPaginas || 1}
          </span>
          <button
            disabled={pagina === totalPaginas}
            onClick={() => setPagina(p => p + 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Siguiente
          </button>
        </div>
      </div>

      {/* MODAL EDITAR HORARIO */}
      {editandoHorario && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: 24,
              borderRadius: 16,
              width: "90%",
              maxWidth: 380,
            }}
          >
            <h3 style={{ marginBottom: 4 }}>
              ✏️ Editar horario — {editandoHorario.profesor_nombre}
            </h3>

            {editandoHorario.lote_id ? (
              <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
                {editandoHorario.tipo_creacion === "semanal"
                  ? "Esto va a cambiar TODAS las fechas futuras de esta serie semanal que aún no tengan cita."
                  : "Esto va a reemplazar TODO el bloque de horarios que se creó junto ese día."}
              </p>
            ) : (
              <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
                Horario antiguo — solo se edita esta fila individual.
              </p>
            )}

            {editandoHorario.lote_id && (
              <div className="campo" style={{ marginBottom: 10 }}>
                <label>Configuración (duración de cita)</label>
                <select
                  value={formEdicion.configuracion_id}
                  onChange={(e) =>
                    setFormEdicion({ ...formEdicion, configuracion_id: e.target.value })
                  }
                >
                  <option value="">Selecciona una configuración</option>
                  {configuraciones.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre} — {c.intervalo_citas_minutos} min
                    </option>
                  ))}
                </select>
              </div>
            )}

            {editandoHorario.lote_id && editandoHorario.tipo_creacion === "semanal" ? (
              <div className="campo" style={{ marginBottom: 10 }}>
                <label>Día de la semana</label>
                <select
                  value={formEdicion.dia_semana}
                  onChange={(e) =>
                    setFormEdicion({ ...formEdicion, dia_semana: e.target.value })
                  }
                >
                  {diasSemana.map((d) => (
                    <option key={d.value} value={d.value}>
                      {d.label}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="campo" style={{ marginBottom: 10 }}>
                <label>Fecha</label>
                <input
                  type="date"
                  value={formEdicion.fecha}
                  onChange={(e) =>
                    setFormEdicion({ ...formEdicion, fecha: e.target.value })
                  }
                />
              </div>
            )}

            <div className="campo" style={{ marginBottom: 10 }}>
              <label>Hora inicio</label>
              <input
                type="time"
                value={formEdicion.hora_inicio}
                onChange={(e) =>
                  setFormEdicion({ ...formEdicion, hora_inicio: e.target.value })
                }
              />
            </div>

            <div className="campo" style={{ marginBottom: 16 }}>
              <label>Hora fin</label>
              <input
                type="time"
                value={formEdicion.hora_fin}
                onChange={(e) =>
                  setFormEdicion({ ...formEdicion, hora_fin: e.target.value })
                }
              />
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn success" onClick={guardarEdicionHorario}>
                <FaSave /> Guardar
              </button>
              <button className="btn secondary" onClick={cerrarEdicionHorario}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}